<questionnaire-form-displayer
    [userFormDetails]="{ QuestionnaireDetails: questionnaire, UserForm: userForm }"
    [printMode]="printMode"
    [previewMode]="true"
    [close]="this.close"
    [printUrl]="'/print/questionnaire/preview/' + questionnaire.FormID"
></questionnaire-form-displayer>